import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { AccountCallStatus } from "./type";



export const CreateCallStatusForm = forwardRef<any, { data: AccountCallStatus }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    return <Form
        formData={data}
        ref={ref}
        validationGroup= "createAccountCallStatus"
    >
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                editorType="dxTextBox"
                label={{
                    text : localize.getString("name")
                }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Description"}
                editorType="dxTextArea"
                label={{
                    text : localize.getString("description")
                }}
            >
                
            </SimpleItem>
        </GroupItem>
    </Form>
})